import { ReactElement } from 'react'

/** Says which parts of the tab are simulated until the SMS ops API ships (plan D4). */
export function PreviewDataNotice(): ReactElement {
  return (
    <div className="mb-6 rounded-lg border border-default bg-surface-subtle px-4 py-3 text-body-sm text-subtle">
      <span className="text-ui-sm text-strong">Preview data. </span>
      Every card, and each section marked Preview, is simulated until the SMS ops API ships. Sections marked Live are
      real records, so their counts won't match the simulated numbers.
    </div>
  )
}
